export const SECTION_ROUTES = [
  {
    "key": "EntranceExams",
    "title": "Entrance Exams",
    "path": "/entrance-exam/",
    "component": "EntranceExams",
    "links": [
      {
        "label": "IMU CET",
        "path": "/entrance-exam/imu-cet/",
        "component": "ImuCet"
      },
      {
        "label": "JEE Main",
        "path": "/entrance-exam/jee-main-entrance-examination/",
        "component": "JeeMainEntranceExamination"
      },
      {
        "label": "JEE Advanced",
        "path": "/entrance-exam/jee-advanced-entrance-examination/",
        "component": "JeeAdvancedEntranceExamination"
      },
      {
        "label": "MAT",
        "path": "/entrance-exam/mat-entrance-examination/",
        "component": "MatEntranceExamination"
      },
      {
        "label": "NATA",
        "path": "/entrance-exam/nata-entrance-examination/",
        "component": "NataEntranceExamination"
      },
      {
        "label": "NIFT",
        "path": "/entrance-exam/nift-entrance-examination/",
        "component": "NiftEntranceExamination"
      },
      {
        "label": "TANCET",
        "path": "/entrance-exam/tancet-management-computer-application-entrance-exam/",
        "component": "TancetManagementComputerApplicationEntranceExam"
      },
      {
        "label": "NEET - UG",
        "path": "/entrance-exam/neet-entrance-examination-ug/",
        "component": "NeetEntranceExaminationUg"
      },
      {
        "label": "NEET - PG",
        "path": "/entrance-exam/neet-pg-entrance-examination/",
        "component": "NeetPgEntranceExamination"
      },
      {
        "label": "AIIMS & JIPMER",
        "path": "/entrance-exam/aiims-jipmer-via-neet/",
        "component": "AiimsJipmerViaNeet"
      },
      {
        "label": "GATE",
        "path": "/entrance-exam/gate-entrance-examination/",
        "component": "GateEntranceExamination"
      },
      {
        "label": "CAT",
        "path": "/entrance-exam/cat-entrance-examination/",
        "component": "CatEntranceExamination"
      },
      {
        "label": "AME CET",
        "path": "/entrance-exam/ame-cet/",
        "component": "AmeCet"
      },
      {
        "label": "CMAT",
        "path": "/entrance-exam/cmat-entrance-examination/",
        "component": "CmatEntranceExamination"
      },
      {
        "label": "CEED",
        "path": "/entrance-exam/ceed-entrance-examination/",
        "component": "CeedEntranceExamination"
      },
      {
        "label": "UCEED",
        "path": "/entrance-exam/uceed-entrance-examination/",
        "component": "UceedEntranceExamination"
      },
      {
        "label": "CLAT",
        "path": "/entrance-exam/clat-entrance-examination/",
        "component": "ClatEntranceExamination"
      },
      {
        "label": "LSAT",
        "path": "/entrance-exam/lsat-entrance-examination-lsat-india/",
        "component": "LsatEntranceExaminationLsatIndia"
      },
      {
        "label": "CUET",
        "path": "/entrance-exam/cuet-entrance-examination-ug/",
        "component": "CuetEntranceExaminationUg"
      }
    ]
  },
  {
    "key": "Counselling",
    "title": "Counselling",
    "path": "/counselling/",
    "component": "Counselling",
    "links": [
      {
        "label": "Law Counselling",
        "path": "/counselling/law-counselling/",
        "component": "LawCounselling"
      },
      {
        "label": "Agriculture Counselling",
        "path": "/counselling/agriculture-counselling/",
        "component": "AgricultureCounselling"
      },
      {
        "label": "Paramedical Counselling",
        "path": "/counselling/paramedical-counselling/",
        "component": "ParamedicalCounselling"
      },
      {
        "label": "Arts & Science Counselling",
        "path": "/counselling/arts-and-science-counselling/",
        "component": "ArtsAndScienceCounselling"
      },
      {
        "label": "Diploma / Polytechnic Counselling",
        "path": "/counselling/diploma-polytechnic-counselling/",
        "component": "DiplomaPolytechnicCounselling"
      },
      {
        "label": "MBA & MCA Counselling (TANCET)",
        "path": "/counselling/mba-mca-counselling-tancet/",
        "component": "MbaMcaCounsellingTancet"
      },
      {
        "label": "Engineering Counselling (TNEA)",
        "path": "/counselling/engineering-counselling-tnea/",
        "component": "EngineeringCounsellingTnea"
      },
      {
        "label": "Medical Counselling (MBBS / BDS & More)",
        "path": "/counselling/medical-counselling-mbbs-bds-more/",
        "component": "MedicalCounsellingMbbsBdsMore"
      },
      {
        "label": "Teacher Education Counselling",
        "path": "/counselling/teacher-education-counselling/",
        "component": "TeacherEducationCounselling"
      }
    ]
  },
  {
    "key": "Scholarships",
    "title": "Scholarships",
    "path": "/scholarship/",
    "component": "Scholarships",
    "links": [
      {
        "label": "7.5 Reservation Scheme",
        "path": "/scholarship/7-5-reservation-scheme/",
        "component": "75ReservationScheme"
      },
      {
        "label": "First Graduate Scholarship",
        "path": "/scholarship/first-graduate-scholarship/",
        "component": "FirstGraduateScholarship"
      },
      {
        "label": "BC / MBC / DNC Scholarship",
        "path": "/scholarship/bc-mbc-dnc-scholarship/",
        "component": "BcMbcDncScholarship"
      },
      {
        "label": "Post-Matric Scholarship",
        "path": "/scholarship/post-matric-scholarship/",
        "component": "PostMatricScholarship"
      },
      {
        "label": "Chief Minister's Merit Award",
        "path": "/scholarship/chief-ministers-merit-award/",
        "component": "ChiefMinistersMeritAward"
      },
      {
        "label": "Pudhumai Penn Scheme",
        "path": "/scholarship/pudhumai-penn-scheme/",
        "component": "PudhumaiPennScheme"
      },
      {
        "label": "Differently-Abled Scholarship",
        "path": "/scholarship/differently-abled-scholarship/",
        "component": "DifferentlyAbledScholarship"
      },
      {
        "label": "Tamizh Pudhalvan Scheme",
        "path": "/scholarship/tamizh-pudhalvan-scheme/",
        "component": "TamizhPudhalvanScheme"
      },
      {
        "label": "Central Sector Scholarship Scheme",
        "path": "/scholarship/central-sector-scholarship-scheme/",
        "component": "CentralSectorScholarshipScheme"
      },
      {
        "label": "Single Parent/Orphan Scholarship",
        "path": "/scholarship/single-parent-or-orphan-scholarship/",
        "component": "SingleParentOrOrphanScholarship"
      },
      {
        "label": "National Means-cum-Merit Scholarship",
        "path": "/scholarship/national-means-cum-merit-scholarship/",
        "component": "NationalMeansCumMeritScholarship"
      },
      {
        "label": "AICTE Pragati & Saksham Scholarship",
        "path": "/scholarship/aicte-pragati-saksham-scholarship/",
        "component": "AictePragatiSakshamScholarship"
      },
      {
        "label": "Adi Dravidar & Tribal Welfare Scholarship",
        "path": "/scholarship/adi-dravidar-tribal-welfare-scholarship/",
        "component": "AdiDravidarTribalWelfareScholarship"
      },
      {
        "label": "Minority Scholarship (Muslim / Christian)",
        "path": "/scholarship/minority-scholarship-muslim-christian/",
        "component": "MinorityScholarshipMuslimChristian"
      },
      {
        "label": "Nalavariyam Scholarship Scheme",
        "path": "/scholarship/nalavariyam-scholarship-scheme/",
        "component": "NalavariyamScholarshipScheme"
      },
      {
        "label": "Sports Scholarship",
        "path": "/scholarship/sports-scholarship/",
        "component": "SportsScholarship"
      },
      {
        "label": "Perasiriyar Anbazhagan Teacher Education Scholarship",
        "path": "/scholarship/perasiriyar-anbazhagan-teacher-education-scholarship/",
        "component": "PerasiriyarAnbazhaganTeacherEducationScholarship"
      }
    ]
  },
  {
    "key": "Services",
    "title": "Our Services",
    "path": "/services/",
    "component": "Services",
    "links": [
      {
        "label": "Direct College Admissions",
        "path": "/services/direct-college-admission-india/",
        "component": "DirectCollegeAdmissionIndia"
      },
      {
        "label": "Online UG / PG Admissions",
        "path": "/services/online-ug-pg-admissions/",
        "component": "OnlineUgPgAdmissions"
      },
      {
        "label": "Distance Education Admissions",
        "path": "/services/distance-education-admissions/",
        "component": "DistanceEducationAdmissions"
      },
      {
        "label": "Abroad Admissions",
        "path": "/services/abroad-admission/",
        "component": "AbroadAdmission"
      }
    ]
  },
  {
    "key": "Tools",
    "title": "Our Tools",
    "path": "/tools/",
    "component": "Tools",
    "links": [
      {
        "label": "Career Path Generator",
        "path": "/tools/career-path-generator/",
        "component": "CareerPathGenerator"
      },
      {
        "label": "Scholarship Finder",
        "path": "/tools/scholarship-finder-tool/",
        "component": "ScholarshipFinderTool"
      },
      {
        "label": "Cutoff Calculator",
        "path": "/tools/cut-off-calculator-tool/",
        "component": "CollegeshineComCutOffCalculatorTamilNadu"
      },
      {
        "label": "Skill Recommendation",
        "path": "/tools/skill-recommentation-tool/",
        "component": "SkillRecommentationTool"
      },
      {
        "label": "Admission HelpLine",
        "path": "/tools/admission-helpline/",
        "component": "AdmissionHelpline"
      },
      {
        "label": "Apply Scholarship",
        "path": "/tools/apply-scholarship/",
        "component": "Scholarship"
      }
    ]
  }]

export const SECTION_ALIASES = [
  { path: '/entrance-exams/', target: '/entrance-exam/' },
  
  { path: '/our-services-2/', target: '/services/' },
  { path: '/our-tools/', target: '/tools/' },
]
